// src/components/kiosk/CodeEntry.js
// 6-digit emailed code entry used by the kiosk walk-in and check-in flows.
import React, { useState } from 'react';

const CodeEntry = ({ email, onSubmit, onResend, submitting, error }) => {
  const [code, setCode] = useState('');

  const handleChange = (e) => {
    setCode(e.target.value.replace(/\D/g, '').slice(0, 6));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.length === 6) onSubmit(code);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-app-bg-secondary-light dark:bg-app-bg-secondary rounded-2xl p-6 border border-app-border-light dark:border-app-border space-y-4"
    >
      <div className="text-center space-y-1">
        <div className="text-base font-bold text-app-text-light dark:text-app-text">Check your email</div>
        <div className="text-xs text-app-text-secondary-light dark:text-app-text-secondary">
          We sent a 6-digit code to <span className="font-semibold">{email}</span>. It expires in 10 minutes.
        </div>
      </div>

      <input
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        autoFocus
        aria-label="6-digit code"
        value={code}
        onChange={handleChange}
        placeholder="••••••"
        className="w-full text-center text-3xl tracking-[0.5em] font-mono py-4 rounded-xl bg-app-input-light dark:bg-app-input border border-app-input-border-light dark:border-app-input-border text-app-text-light dark:text-app-text outline-none focus:border-app-accent"
      />

      {error && (
        <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-3">
          <p className="text-red-400 text-xs">{error}</p>
        </div>
      )}

      <button
        type="submit"
        disabled={submitting || code.length !== 6}
        className="w-full py-4 rounded-2xl bg-app-accent text-black text-base font-semibold hover:opacity-90 disabled:opacity-50"
      >
        {submitting ? 'Checking…' : 'Continue'}
      </button>

      {onResend && (
        <button
          type="button"
          onClick={() => { setCode(''); onResend(); }}
          disabled={submitting}
          className="w-full py-2 text-xs text-app-text-secondary-light dark:text-app-text-secondary underline"
        >
          Didn&apos;t get it? Send a new code
        </button>
      )}
    </form>
  );
};

export default CodeEntry;
